import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import getBaseUrl from "../getBaseUrl";

const maxRetries = 2;

const dynamicBaseQuery = async (args: any, api: any, extraOptions: any) => {
  const rawBaseQuery = fetchBaseQuery({ baseUrl: getBaseUrl() });
  return rawBaseQuery(args, api, extraOptions);
};

const baseQuery = retry(dynamicBaseQuery, { maxRetries });

export const gitTokenAPI = createApi({
  reducerPath: "gitTokenAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGitToken"],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET GITHUB TOKEN STATUS */
    getGitToken: builder.query({
      query: (body: any) => ({
        url: "/github-token",
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGitToken"],
    }),
    //* *********************************************************** */
    //* SAVE OR UPDATE GITHUB TOKEN */
    putGitToken: builder.mutation({
      query: (body: any) => ({
        url: "/github-token",
        method: "put",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGitToken"],
    }),
    //* *********************************************************** */
    //* DELETE GITHUB TOKEN */
    deleteGitToken: builder.mutation({
      query: (body: any) => ({
        url: "/github-token",
        method: "delete",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGitToken"],
    }),
    //* *********************************************************** */
  }),
});

export const { useLazyGetGitTokenQuery, usePutGitTokenMutation, useDeleteGitTokenMutation } =
  gitTokenAPI;
